import { isInBoxLayoutEditor } from "./isInBoxLayoutEditor";

// The BLE is reused for box-style-library edits (editBoxStyle=true) and for
// background table/legend box-properties edits (false); only the former gets the library sidebar.
export function isInBoxStyleLibraryEditor(wsMgr) {
  return isInBoxLayoutEditor() && wsMgr?.fLayoutPanel?.EditBoxStyle?.() === true;
}
